// extracted by mini-css-extract-plugin
export default {"main_div":"EditScreenCompleteSubmissionHeaderInfoDiv_main_div__mEwi5","text":"EditScreenCompleteSubmissionHeaderInfoDiv_text__P0zBD"};